import axios from "axios";
import store from "../redux/store";
import { getClientID, getCommandByIndex, getSN, getURL } from "../redux/selectors";

const printDoc = async ({ format, template, key, tabID }) => {
  const state = store.getState();
  const url = getURL(state);
  const clientID = getClientID(state);
  const serialnumber = getSN(state);
  const command = getCommandByIndex(state, tabID);
  const object = `${serialnumber}/object=${command}`;

  return await axios
    .post(`${process.env.REACT_APP_BACKEND_DOMAIN}/d1services`, {
      url,
      data: {
        service: "printDoc",
        clientID,
        object,
        format,
        template,
        key,
        appID: process.env.REACT_APP_SOFTONE_APPID,
      },
    })
    .then((res) => res.data)
    .catch((er) => ({ success: false, error: er.message }));
};

export default printDoc;
